import {PaisDTO} from '../PaisDTO';
import {TipoDocumentoDTO} from '../TipoDocumentoDTO';
import {ReceptorCFEDTO} from '../ReceptorCFEDTO';

export class DatosInicioReceptorDTO
{
  paisesDTOs: Array<PaisDTO>;
  tiposDocumentosDTOs: Array<TipoDocumentoDTO>;
  codigoTipoDocumentoSeleccionado: number;
  codigoPaisSeleccionado: string;
  receptoresCFEsDisponiblesDTOs: Array<ReceptorCFEDTO>;
  receptoresCFEDTOsDisponiblesCopia: Array<ReceptorCFEDTO>;
  esABM: boolean;

  constructor()
  {
    this.paisesDTOs = new Array<PaisDTO>();
    this.tiposDocumentosDTOs = new Array<TipoDocumentoDTO>();
    this.receptoresCFEsDisponiblesDTOs = new Array<ReceptorCFEDTO>();
    this.esABM = false;
  }
}
